import { useCallback, useState } from "react";
import { Modal } from "antd";
import type { HomeCourseItem } from "../../SpaceType";
import { formatLearner } from "../../spacePageUtils";

/** 教学视频 */
export function SpaceHomeCoursePreview(props: {
  courses: HomeCourseItem[];
}): JSX.Element {
  const { courses } = props;
  const [videoUrl, setVideoUrl] = useState<string | null>(null);
  const [videoTitle, setVideoTitle] = useState("");

  const onCloseVideo = useCallback(() => {
    setVideoUrl(null);
    setVideoTitle("");
  }, []);

  const onPlay = useCallback((url: string, title: string) => {
    if (!url || url.trim() === "") {
      return;
    }
    setVideoUrl(url.trim());
    setVideoTitle(title);
  }, []);

  if (courses.length === 0) {
    return <></>;
  }

  return (
    <>
      <section className="space-home-feed__section" aria-label="教学视频">
        <p className="space-home-feed__section-hint">教学视频</p>
        <div className="space-home-feed__grid" role="list">
          {courses.map((c, i) => {
            const hasVideo = c.videoUrl != null && c.videoUrl.trim() !== "";
            return (
              <button
                key={`${c.title}-${i}`}
                type="button"
                className={
                  hasVideo
                    ? "space-home-feed__tile"
                    : "space-home-feed__tile space-home-feed__tile--static"
                }
                role="listitem"
                onClick={() => {
                  if (hasVideo) {
                    onPlay(c.videoUrl as string, c.title);
                  }
                }}
              >
                <div className="space-home-feed__tile-thumb">
                  <img src={c.coverUrl} alt="" loading="lazy" />
                  {hasVideo ? (
                    <span className="space-home-feed__play-icon" aria-hidden />
                  ) : null}
                </div>
                <p className="space-home-feed__tile-title">{c.title}</p>
                {formatLearner(c.learnerCount) ? (
                  <p className="space-home-feed__tile-meta">{formatLearner(c.learnerCount)}</p>
                ) : null}
              </button>
            );
          })}
        </div>
      </section>

      <Modal
        open={videoUrl != null && videoUrl !== ""}
        onCancel={onCloseVideo}
        footer={null}
        width={Math.min(960, typeof window !== "undefined" ? window.innerWidth - 32 : 960)}
        className="space-home-feed__video-modal"
        title={videoTitle}
        destroyOnClose
        centered
      >
        {videoUrl ? (
          <video
            className="space-home-feed__video"
            src={videoUrl}
            controls
            playsInline
            preload="metadata"
          />
        ) : null}
      </Modal>
    </>
  );
}
